
export const contextMenuConfig = {
    sortDown: 'sortDown',
    sortUp: 'sortUp',
    groupBy: 'groupBy'
}